import { asScaled } from '../utils';
/* ------- button布局尺寸 start ------- */
const buttonLayout = {
    // icon调整距离
    iconPadding: 2,
    // icon与文字的间距
    iconSpace: 4,
    // 按钮高度
    height: {
        large: 44,
        medium: 40,
        small: 32,
        mini: 28,
        mini_s: 24,
        mini_xs: 20
    },
    minWidth: {
        large: 90,
        medium: 80,
        small: 68,
        mini: 52,
        mini_s: 48,
        mini_xs: 48
    },
    paddingHorizontal: {
        large: 20,
        medium: 20,
        small: 20,
        mini: 12,
        mini_s: 12,
        mini_xs: 12
    }
};
const buttonLayoutScaled = asScaled(buttonLayout);
export const button = {
    scaled: buttonLayoutScaled,
    unscaled: buttonLayout
};
